import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CabsandTimesheetCreateAddPage } from './cabsand-timesheet-create-add';

@NgModule({
  declarations: [
    CabsandTimesheetCreateAddPage,
  ],
  imports: [
    IonicPageModule.forChild(CabsandTimesheetCreateAddPage),
  ],
})
export class CabsandTimesheetCreateAddPageModule {}



// WEBPACK FOOTER //
// ./src/pages/cabsand-timesheet-create-add/cabsand-timesheet-create-add.module.ts